export class BreachType {
  public id?: string;
  public name: string;
}
